import { StartPageIcon } from 'components/Atoms/Icon';
import { lazy } from 'react';
import * as routeName from '../route-name';
import * as routePath from '../route-path';
import { USER_LEVEL_TYPE } from 'constants/common';

const StaredPage = lazy(() => import('components/Pages/StartedPage'));

export const startedRoutes = [
  {
    path: routePath.STARTED_PAGE,
    name: routeName.STARTED_PAGE,
    component: StaredPage,
    exact: true,
    showMenu: true,
    defaultShow: true,
    hasBorderBt: true,
    icon: StartPageIcon,
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
];
